import * as _ from "lodash"
import { PrestationQuote } from "@requests"

export interface IHasBaseAccomodationQuoteObject {
    getBaseAccomodationQuoteObject(): PrestationQuote | undefined
    setBaseAccomodationQuoteObject(baseQuoteObject: PrestationQuote): void
}

function hasBaseAccomodationQuoteObject<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasBaseAccomodationQuoteObject {
        private baseAccomodationQuoteObject: PrestationQuote | undefined

        constructor(...args: any[]) {
            super(...args);
        }

        public getBaseAccomodationQuoteObject(): PrestationQuote | undefined {
            return this.baseAccomodationQuoteObject
        }
        public setBaseAccomodationQuoteObject(baseAccomodationQuoteObject: PrestationQuote): void {
            this.baseAccomodationQuoteObject = _.cloneDeep(baseAccomodationQuoteObject)
        }
    };
}

export default hasBaseAccomodationQuoteObject